//Lazy loading
export default function lazyLoad() {
	const lazyLoad = Array.prototype.slice.call(document.body.querySelectorAll(".js-lazy-load"));
	const options = {
		rootMargin: "0px",
		threshold: [0]
	};
	const lazyLoader = (el) => {
		el.forEach(t => {
			if (t.intersectionRatio > 0) {
				// console.log(t)
				const target = t.target;
				const src = target.dataset.src;
				const srcset = target.dataset.srcset;
				// const imgloader = new Image();
				// imgloader.addEventListener("load",function() {
				// 	target.setAttribute("src", src);
				// 	if (srcset !== undefined) {
				// 		target.setAttribute("srcset", srcset);
				// 	}
				// 	target.classList.add("lazy-loaded");
				// });
				// imgloader.setAttribute("src", src);
				// if (srcset !== undefined) {
				// 	imgloader.setAttribute("srcset", srcset);
				// }
				target.addEventListener("load", function () {
					this.classList.add("lazy-loaded");
				});
				target.setAttribute("src", src);
				if (srcset !== undefined) {
					target.setAttribute("srcset", srcset);
				}
				isObserver.unobserve(target);
			}
		});
	};
	const isObserver = new IntersectionObserver(lazyLoader, options)
	lazyLoad.forEach(el => {
		isObserver.observe(el);
	});
}